// extracted by mini-css-extract-plugin
export default {"zoomControls":"R--z","zoomControlButton":"S--z","zoomBanner":"T--z","bannerButton":"U--z","imageButton":"V--z","zoom":"W--z","zoomContent":"X--z"};